import React from "react";
import { Box } from "@mui/material";
import { BsWallet2, BsArrowRepeat } from "react-icons/bs";
import { MdFace3 } from "react-icons/md";

const raleway = { fontFamily: "'Geist', sans-serif" };
const geistMono = { fontFamily: "'Geist Mono', monospace" };
const instrumentSerif = { fontFamily: "'Instrument Serif', serif" };

const STEPS = [
  {
    Icon: BsWallet2,
    content: (
      <>
        <span style={{ fontWeight: 600 }}>
          Z-ForHer is different from a regular loan.
        </span>{" "}
        Instead of getting money once and finishing it, you’re given a set
        amount you can access whenever your business needs it.
      </>
    ),
  },
  {
    Icon: BsArrowRepeat,
    content:
      "You can take from it, pay back what you used, and access it again without going through a new application each time. It’s a simple, flexible way to keep your business running smoothly, especially when you need to restock, handle urgent expenses, or take advantage of new opportunities.",
  },
  {
    Icon: MdFace3,
    content:
      "Z-ForHer is currently available only to women entrepreneurs in Anambra State.",
    highlight: true,
  },
];

const Explanation = () => {
  return (
    <Box
      sx={{
        boxSizing: "border-box",
        padding: "clamp(48px, 6.94vw, 100px) clamp(20px, 5.56vw, 80px)",
      }}
    >
      <div style={{ maxWidth: "1440px", margin: "0 auto" }}>
        <div
          className="flex gap-12 sm:flex-col sm:gap-8"
          style={{ alignItems: "flex-start" }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "clamp(16px, 1.67vw, 24px)",
              maxWidth: "560px",
              flex: "0 0 auto",
            }}
          >
            {/* Label */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <span
                style={{
                  width: "8px",
                  height: "8px",
                  borderRadius: "50%",
                  backgroundColor: "#295B4A",
                  flexShrink: 0,
                  display: "inline-block",
                }}
              />
              <span
                style={{
                  ...geistMono,
                  fontWeight: 500,
                  fontSize: "12px",
                  lineHeight: 1,
                  letterSpacing: "0.1em",
                  color: "#295B4A",
                  textTransform: "uppercase",
                }}
              >
                How it works
              </span>
            </div>

            <h2
              style={{
                ...instrumentSerif,
                fontWeight: 400,
                fontSize: "clamp(28px, 4.17vw, 60px)",
                lineHeight: 1.1,
                letterSpacing: "-0.01em",
                color: "#132A22",
                margin: 0,
              }}
            >
              Not your regular loan, <br /> here’s how it works.
            </h2>

            <p
              style={{
                ...raleway,
                fontWeight: 400,
                fontSize: "clamp(14px, 1.25vw, 18px)",
                lineHeight: 1.6,
                color: "#3F5445",
                margin: 0,
              }}
            >
              A reusable line of credit, sized for your business and the way it
              actually moves.
            </p>
          </div>

          <div className="flex flex-col w-full" style={{ gap: 0 }}>
            {STEPS.map(({ Icon, content, highlight }, i) => (
              <div
                key={i}
                className="flex sm:gap-4"
                style={{
                  gap: "24px",
                  alignItems: "flex-start",
                  paddingTop: i === 0 ? 0 : "clamp(20px, 2.22vw, 32px)",
                  paddingBottom: "clamp(20px, 2.22vw, 32px)",
                  borderTop: i === 0 ? "none" : "1px solid #D1E0D7",
                }}
              >
                <div
                  style={{
                    width: "60px",
                    height: "60px",
                    borderRadius: "9999px",
                    background: "#E1EFE7",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <Icon size={24} color="#295B4A" />
                </div>
                <p
                  style={{
                    ...raleway,
                    fontWeight: highlight ? 600 : 400,
                    fontSize: "clamp(16px, 1.39vw, 20px)",
                    lineHeight: "32px",
                    color: "#132A22",
                    margin: 0,
                    paddingTop: "10px",
                    maxWidth: "600px",
                  }}
                >
                  {content}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Box>
  );
};

export default Explanation;
